import CollectionName from '../utils/collections';
import BaseDocument from './BaseDocument';

/**
 * Class representing an User Presence.
 * An user presence is a document that tracks the presence of a user.
 *
 * @class UserPresence
 * @extends BaseDocument
 */
class UserPresence extends BaseDocument {
  constructor(id, opts) {
    super(`${CollectionName.USER_PRESENCE}/${id}`, opts);
  }

  /**
   * The online status of the user.
   * @returns {string}
   */
  get isOnline() {
    return this.data.isOnline;
  }

  /**
   * Gets a user presence by its id.
   * @param {string} userId - Id of the user
   * @returns {Promise<UserPresence>} The user presence from firestore
   */
  static async getUserPresenceByUserId(userId) {
    const userPresenceDoc = new UserPresence(userId);
    await userPresenceDoc.init();
    return userPresenceDoc;
  }
}

export default UserPresence;
